import React from "react"
import {Cascader, Row, Col, Radio} from 'antd';
import 'antd/dist/antd.css';
import {StaticQuery, graphql} from "gatsby"
import '../styles/style_cities_comparision.css';

import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  Line,
} from "react-simple-maps"


class CompareCities extends React.Component {
  constructor(props) {
    super(props);
    this.onChange3 = this.onChange3.bind(this);

    this.state = {
      selected_city_1: ["Long Beach"],
      selected_city_2: ["Washington"],
      cities_list: [
        {
          value: "Long Beach",
          coordinates: [-118.1103, 33.8241],
          label: "Long Beach"
        },
        {
          value: "Washington",
          coordinates: [-77.0592, 38.8565],
          label: "Washington"
        },
        {
          value: "Orlando",
          coordinates: [-81.343, 28.4317],
          label: "Orlando"
        },
        {
          value: "Seattle",
          coordinates: [-122.3076, 47.4497],
          label: "Seattle"
        },
        {
          value: "Portland",
          coordinates: [-122.6001, 45.56],
          label: "Portland"
        },
        {
          value: "Austin",
          coordinates: [-97.6667, 30.1802],
          label: "Austin"
        },
        {
          value: "Tampa",
          coordinates: [-82.4895, 27.9625],
          label: "Tampa"
        },
        {
          value: "San Diego",
          coordinates: [-117.1593, 32.7185],
          label: "San Diego"
        },
        {
          value: "San Francisco",
          coordinates: [-122.3929, 37.6216],
          label: "San Francisco"
        },
        {
          value: "New York",
          coordinates: [-73.7827, 40.6472],
          label: "New York"
        },
        {
          value: "Denver",
          coordinates: [-104.7557, 39.7783],
          label: "Denver"
        },
        {
          value: "Atlanta",
          coordinates: [-84.4236, 33.6568],
          label: "Atlanta"
        },
        {
          value: "Boston",
          coordinates: [-71.0257, 42.3642],
          label: "Boston"
        },
        {
          value: "Miami",
          coordinates: [-80.2919, 25.7763],
          label: "Miami"
        },
        {
          value: "Phoenix",
          coordinates: [-112.0421, 33.4413],
          label: "Phoenix"
        },
        {
          value: "Charlotte",
          coordinates: [-80.8964, 35.2358],
          label: "Charlotte"
        },
        {
          value: "Chicago",
          coordinates: [-87.6501, 41.85],
          label: "Chicago"
        },
        {
          value: "Nashville",
          coordinates: [-86.6609, 36.1633],
          label: "Nashville"
        },
        {
          value: "New Orleans",
          coordinates: [-90.2479, 29.9912],
          label: "New Orleans"
        },
        {
          value: "Las Vegas",
          coordinates: [-115.1365, 36.1008],
          label: "Las Vegas"
        },
        {
          value: "Los Angeles",
          coordinates: [-118.3941, 33.9631],
          label: "Los Angeles"
        },
        {
          value: "Des Moines",
          coordinates: [-93.6618, 41.5476],
          label: "Des Moines"
        },
        {
          value: "Minneapolis",
          coordinates: [-93.2007, 44.8828],
          label: "Minneapolis"
        },
        {
          value: "Houston",
          coordinates: [-95.3299, 29.9368],
          label: "Houston"
        },
        {
          value: "Asheville",
          coordinates: [-82.4966, 35.4499],
          label: "Asheville"
        },
      ],
      min1: 47.66,
      average1: 65.51,
      max1: 87.26,

      min2: 12.92,
      average2: 60.05,
      max2: 91.04,

      coord1: [-118.1103, 33.8241],
      coord2: [-77.0592, 38.8565],


      value_unit: "F",
      avg_or_specific_time: "all_year",
      min_season: "min_all_year",
      mean_season: "mean_all_year",
      max_season: "max_all_year",
      showing_line: Array(25).fill(0),
    };
  }

  onChange1(value, selectedOptions) {
    this.setState({selected_city_1: value})
    for (var i = 0; i < this.props.data_passed.edges.length; i++) {
      if (this.props.data_passed.edges[i].node.field1 === value[0]) {
        this.setState(
          {
            min1: this.props.data_passed.edges[i].node[this.state.min_season],
            average1: this.props.data_passed.edges[i].node[this.state.mean_season],
            max1: this.props.data_passed.edges[i].node[this.state.max_season],
            coord1: this.state.cities_list[i].coordinates,
          }
        )
      }
    }
  }

  onChange2(value, selectedOptions) {
    this.setState({selected_city_2: value})
    for (var i = 0; i < this.props.data_passed.edges.length; i++) {
      if (this.props.data_passed.edges[i].node.field1 === value[0]) {
        this.setState(
          {
            min2: this.props.data_passed.edges[i].node[this.state.min_season],
            average2: this.props.data_passed.edges[i].node[this.state.mean_season],
            max2: this.props.data_passed.edges[i].node[this.state.max_season],
            coord2: this.state.cities_list[i].coordinates,
          }
        )
      }
    }
  }

  onChange3(e) {
    this.setState({selected_city_2: [e.target.id]});
    for (var i = 0; i < this.props.data_passed.edges.length; i++) {
      if (this.props.data_passed.edges[i].node.field1 === e.target.id) {
        this.setState(
          {
            min2: this.props.data_passed.edges[i].node[this.state.min_season],
            average2: this.props.data_passed.edges[i].node[this.state.mean_season],
            max2: this.props.data_passed.edges[i].node[this.state.max_season],
            coord2: this.state.cities_list[i].coordinates,
          }
        )
      }
    }
  }

  onMouseOver(e) {
    var showing_line = this.state.showing_line
    for (var i = 0; i < this.props.data_passed.edges.length; i++) {
      if (this.props.data_passed.edges[i].node.field1 === e.target.id) {
        showing_line[i] = 1
        this.setState(
          {
            showing_line: showing_line
          }
        )
      }
    }
  }

  onMouseOut(e) {
    var showing_line = this.state.showing_line
    for (var i = 0; i < this.props.data_passed.edges.length; i++) {
      if (this.props.data_passed.edges[i].node.field1 === e.target.id) {
        showing_line[i] = 0
        this.setState(
          {
            showing_line: showing_line
          }
        )
      }
    }
  }

  onChangeToggle1 = e => {
    this.setState({
      value_unit: e.target.value,
    });
  };
  onChangeToggle2 = e => {
    this.setState({
        avg_or_specific_time: e.target.value,
        min_season: "min_" + e.target.value,
        mean_season: "mean_" + e.target.value,
        max_season: "max_" + e.target.value,

      }, function () {
        this.onChange1(this.state.selected_city_1)
        this.onChange2(this.state.selected_city_2)
      }
    );
  };

  filter(inputValue, path) {
    return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
  }

  f2c(f) {
    return Math.round(10 * 5 / 9 * (f - 32)) / 10;
  }

  render() {
    const rows_list_cities = [];
    for (var i = 0; i < this.props.data_passed.edges.length; i++) {
      rows_list_cities.push(<Line
        key={i + 50}
        from={this.state.coord1}
        to={this.state.cities_list[i].coordinates}
        stroke="#999"
        opacity={this.state.showing_line[i]}
        strokeWidth={2}
        strokeLinecap="round"
      />);
    }

    for (i = 0; i < this.props.data_passed.edges.length; i++) {
      rows_list_cities.push(<Marker coordinates={this.state.cities_list[i].coordinates} key={i}>
        <circle r={8}
                fill="#999"
                id={this.state.cities_list[i].value}
                onClick={(e) => {
                  this.onChange3(e)
                }}
                onMouseOver={(e) => {
                  this.onMouseOver(e)
                }}
                onFocus={(e) => {
                  this.onMouseOver(e)
                }}
                onMouseOut={(e) => {
                  this.onMouseOut(e)
                }}
                onBlur={(e) => {
                  this.onMouseOut(e)
                }}
                style={{
                  cursor: 'pointer',
                  hover: {fill: "#000", r: 12, border: 30},
                }}
        />
      </Marker>);
    }


    return (
      <>

          <Radio.Group onChange={this.onChangeToggle1.bind(this)} value={this.state.value_unit}>
            <Radio.Button value={"C"}>°C</Radio.Button>
            <Radio.Button value={"F"}>°F</Radio.Button>
          </Radio.Group> Note: average temperatures are lower than afternoon temperature.
        <br/>      <br/>

        <Row>
          <Col span={12}> From:
            <Cascader
              value={this.state.selected_city_1}
              options={this.state.cities_list}
              onChange={this.onChange1.bind(this)}
            />
          </Col>

          <Col span={12}> To:
            <Cascader
              value={this.state.selected_city_2}
              options={this.state.cities_list}
              onChange={this.onChange2.bind(this)}
            />
          </Col>
        </Row>
        <br/>

        {this.state.value_unit === "F" ? (
          <Row>
            <Col span={8}>

              <Row style={{textAlign: 'right'}}>
                <p>{this.state.min1} °{this.state.value_unit}</p>
                <p>{this.state.average1} °{this.state.value_unit}</p>
                <p>{this.state.max1} °{this.state.value_unit}</p>
              </Row>

            </Col>
            <Col span={4} style={{textAlign: 'center'}}>
              <Row>
                <p>Min</p>
                {/*<p>Median</p>*/}
                <p>Avg</p>
                <p>Max</p>
              </Row>
            </Col>
            <Col span={8}>
              <Row>
                <p>{this.state.min2} °{this.state.value_unit}</p>
                <p>{this.state.average2} °{this.state.value_unit}</p>
                <p>{this.state.max2} °{this.state.value_unit}</p>
              </Row>
            </Col></Row>) : (

          <Row>

            <Col span={8}>

              <Row style={{textAlign: 'right'}}>
                <p>{this.f2c(this.state.min1)} °{this.state.value_unit}</p>
                <p>{this.f2c(this.state.average1)} °{this.state.value_unit}</p>
                <p>{this.f2c(this.state.max1)} °{this.state.value_unit}</p>
              </Row>

            </Col>
            <Col span={4} style={{textAlign: 'center'}}>
              <Row>
                <p>Min</p>
                <p>Avg</p>
                <p>Max</p>
              </Row>
            </Col>
            <Col span={8}>
              <Row>
                <p>{this.f2c(this.state.min2)} °{this.state.value_unit}</p>
                <p>{this.f2c(this.state.average2)} °{this.state.value_unit}</p>
                <p>{this.f2c(this.state.max2)} °{this.state.value_unit}</p>
              </Row>
            </Col></Row>
        )}

        <ComposableMap
          projection="geoAlbersUsa"
          width={980}
          height={551}
          style={{
            width: "100%",
            height: "auto",
          }}>
          <Geographies geography={"../../gadm36_USA_0.json"}>
            {({geographies}) => geographies.map(geo =>
              <Geography key={geo.rsmKey}
                         geography={geo}
                         fill="#DDD"
                         stroke="#FFF"

                         style={{
                           default: {outline: "none", border: 0},
                           hover: {outline: "none", border: 0},
                           pressed: {
                             outline: "none", border: 0
                           },
                         }}
              />
            )}
          </Geographies>

          {rows_list_cities}

          <Marker coordinates={this.state.coord1}>
            <circle r={8} fill="#F53"/>
          </Marker>
          <Marker coordinates={this.state.coord2}>
            <circle r={8} fill="#F53"/>
          </Marker>
          <Line
            from={this.state.coord1}
            to={this.state.coord2}
            stroke="#FF5533"
            strokeWidth={2}
            strokeLinecap="round"
          />
        </ComposableMap>


        <Row type="flex" >
          <Radio.Group onChange={this.onChangeToggle2.bind(this)} value={this.state.avg_or_specific_time}>
            <Radio.Button value={"all_year"}>Year</Radio.Button>
            <Radio.Button value={"spring"}>Spring</Radio.Button>
            <Radio.Button value={"summer"}>Summer</Radio.Button>
            <Radio.Button value={"autumn"}>Fall</Radio.Button>
            <Radio.Button value={"winter"}>Winter</Radio.Button>
          </Radio.Group>

        </Row><br/>

      </>
    )
  }
};


export default () => (
  <StaticQuery
    query={graphql`
      query {
    allAllCitiesAveragesCombinedCsv {
      edges {
        node {
          min_all_year
          max_all_year
          mean_all_year
          min_autumn
          min_spring
          min_summer
          min_winter
          mean_autumn
          mean_spring
          mean_summer
          mean_winter
          max_autumn
          max_spring
          max_summer
          max_winter
        field1          
        }
      }
    }
      }
    `}
    render={(data) => (
      <CompareCities data_passed={data.allAllCitiesAveragesCombinedCsv}/>
    )}
  />
)
